import styled, { keyframes } from 'styled-components';
import { Row } from 'antd';

import { media } from '~src/styles/media-templates';
import { PeriodSelectorContainer } from '~src/modules/reports/reportsHeader/containers/ReportsHeader.sc';

const highlightColor = '#ffffffff'

export const highlight = keyframes` 
  20% {
    border-color: ${highlightColor};
    background: ${highlightColor};
    box-shadow: inset 0 0 0 3px ${highlightColor};
  }
  100% {
    background: inherit;
    border-color: rgba(0, 0, 0, 0.1);
    box-shadow: none;
  }
}`

export const FiltersContainer = styled.div<{ $disabled?: boolean; }>`
  border: 1px solid ${({ theme }) => theme.black.a1};
  border-left: 0;
  border-right: 0;
  padding: 10px 75px;
  display: flex;
  align-items: center;
  opacity: ${(p) => (p.$disabled ? 0.7 : 1)};
  pointer-events: ${(p) => (p.$disabled ? 'none' : 'unset')};
  ${media.tablet`
    padding: 0px 6px;
  `}
  &.highlighted {
    animation: ${highlight} 3s linear;
  }
`;

export const FilterInput = styled.div<{$isFixWidth?: boolean}>`
  flex-grow: 1;
  ${({ $isFixWidth }) => $isFixWidth && `max-width: 400px;`};
`;

export const FiltersRow = styled(Row)`
  display: flex;
  align-items: center;
  width: 100%;
  ${media.tablet`
    padding: 0px 6px;
    flex-direction: column;
  `}
`;

export const AttrSelectorCol = styled.div`
  width: 345px;
  padding: 15px 15px 15px 0;
  border-right: 1px solid ${({ theme }) => theme.black.a1};
  flex: 0 0 auto;
`;

export const FilterCol = styled.div`
  display: flex;
`;

export const FilterTitleAndDescription = styled.div`
  display: flex;
  flex-direction: column;
  max-width: 200px;
  padding:  2px 15px 2px 0px;
  margin-right: 40px;
`;

export const FilterTitle = styled.div`
  font-weight: 600;
  min-width: 200px;
  vertical-align: center;
  text-transform: capitalize;
  flex-grow: 1;
`;

export const SelectorBox = styled.div<{ $inactive?: boolean; $show?: boolean; $isFirstChild?: boolean }>`
  margin-right: 20px;
  padding: 0px 15px;
  ${({ $isFirstChild }) => $isFirstChild && `padding-left: 0px;`};
  opacity: ${({ $inactive, $show }) => ($show ? 0 : $inactive ? 0.5 : 1)};
`;

export const ComparePeriodSelectorContainer = styled(PeriodSelectorContainer)`
  padding: 0;
`;

export const SelectorStep = styled.div`
  padding: 15px 25px;
  font-size: 1.4rem;
  font-weight: bold;
  display: flex;
  flex-direction: row;
  ${media.tablet`
    padding: 0px 6px;
    justify-content: 'center';
  `}
`;

export const FilterDescription = styled.div`
  max-height: 100px;
  font-size: 0.8rem;
  color: ${({ theme }) => theme.baseBlue.a6};
  transition: all 300ms;
  word-wrap: break-word;
`;
